"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityMetricChartGrid = FacilityMetricChartGrid;
var jsx_runtime_1 = require("react/jsx-runtime");
var facility_dashboard_1 = require("../../../utils/facility-dashboard");
var text_component_1 = require("../../ui/text-component");
var facility_metric_chart_1 = require("./facility-metric-chart");
function FacilityMetricChartGrid(props) {
    var summary = props.summary, selectedArea = props.selectedArea;
    var definitions = (0, facility_dashboard_1.getChartMetricDefinitions)(summary);
    if (!definitions.length) {
        return (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", className: "py-6", label: "No readings in this period." });
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 xl:grid-cols-2 gap-4", children: definitions.map(function (definition) { return ((0, jsx_runtime_1.jsx)(facility_metric_chart_1.FacilityMetricChart, { definition: definition, devices: summary.devices, series: summary.series.filter(function (entry) { return entry.metric === definition.key; }), target: (0, facility_dashboard_1.getMetricTarget)(selectedArea, definition.key) }, definition.key)); }) }));
}
